export const Bridge = ({ size = 24, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6017 10V18H21V6C19.7625 6 18.722 7.19391 18.722 8.66667C18.1033 8.66667 17.6017 9.26373 17.6017 10ZM17.6017 10H6.39834M6.39834 10V18H3V6C4.23748 6 5.27801 7.19391 5.27801 8.66667C5.89669 8.66667 6.39834 9.26373 6.39834 10ZM5.27801 7.33336H18.722M17.6017 16.243C16.3974 14.0874 14.3381 12.6667 12 12.6667C9.6619 12.6667 7.60262 14.0874 6.39834 16.243M8.639 13.737V10M10.8797 12.7773V10M13.1203 12.7773V10M15.361 13.737V10"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
